<template>

<div class="user">
   
 
	  <div class="topheader header bg-color-red">
        <div class="topheader-left">
		 <div  @click="goBack()">
        <img src="@assets/images/back2.png"   style="width:20px;height:20px;margin-top:3px"/>
      </div>
		</div>
        <div class="topheader-center">修改密码</div>
        <div class="topheader-right"> </div>
    </div>
	
	 
  <div class="ChangePassword" style="margin-top:120px">
    
    <div class="list">
	
	  
	 
	<div class="item">
        <input type="password" placeholder="原密码" v-model="oldpassword" />
      </div>
      <div class="item">
        <input type="password" placeholder="设置新密码" v-model="password" />
      </div>
      <div class="item">
        <input type="password" placeholder="确认新密码" v-model="password2" />
      </div>
	  
	   
     
    </div>
    <div class="confirmBnt bg-color-red" @click="confirm">确认修改</div>
  </div>
   </div>
</template>
<style scoped>
.ChangePassword .phone  {
  width: 2rem;
  text-align: center;
  color:white;
}
.codeVal {
  width: 1.5rem;
  height: 0.5rem;
}
.codeVal img {
  width: 100%;
  height: 100%;
}
</style>
<script>
// import { mapGetters } from "vuex";
 
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import store from "@utils/store/cookie";
 
 
 
import {
  registerReset,
  registerVerify,
  getUserInfo,
  getCodeApi
} from "@api/user";
import { VUE_APP_API_URL } from "@utils";

export default {
  name: "ChangePassword",
  components: {},
  props: {},
  data: function() {
    return {

	 oldpassword: "",
      password: "",
      password2: "",
      isShowCode: false
    };
  },
 
 
  mounted: function() {
   // this.getCode();
   // this.getUserInfo();
  },
  methods: {
     goBack() {
    
	this.$router.replace({ path: "/user" });
		//this.$router.go(-1);
		return false;
		
    
    },
  
    async confirm() {
      let that = this;
      const { oldpassword, password, password2 } = that;
      try {
        await that
          .$validator({
		  oldpassword: [
              required(required.message("原密码")) 
            ],
            password: [
              required(required.message("新密码"))
            ]
          })
         
      } catch (e) {
        return validatorDefaultCatch(e);
      }
	  
 
      if (password !== password2) return that.$dialog.error("两次密码不一致");
	  
	    const userInfo = localStorage.getItem('userInfo'); 
   const user = JSON.parse(userInfo);
 
   
const uid = user.uid;
 


      registerReset({
        uid: uid,
		  oldpassword: that.oldpassword,
        password: that.password 
      })
        .then(res => {
		
		console.log(res);
		 
          that.$dialog.success(res.msg).then(() => {
            that.$router.push({ name: "Login" });
          });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    }
    
  }
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
</style>